import React from 'react';
import Svg from 'react-inlinesvg';
import Arrow from '../../../../assets/icons/WebExperience_Icon-Arrow.svg';
import { IconWrap, SectionText, StyledMenuItem, ActionTextWrap, DemoText } from './styled';

const MenuItem = ({ icon, title, onClick, id, selectedDemo, actionText }) => {
  return (
    <StyledMenuItem onClick={() => onClick(id)} selected={selectedDemo && selectedDemo.id === id}>
      <IconWrap selected={selectedDemo && selectedDemo.id === id}>
        <Svg src={icon} className="demo-icon" />
      </IconWrap>
      <SectionText>
        <DemoText selected={selectedDemo && selectedDemo.id === id}>{title}</DemoText>
        <ActionTextWrap selected={selectedDemo && selectedDemo.id === id}>
          <DemoText selected={selectedDemo && selectedDemo.id === id}>{actionText}</DemoText>
          <Svg src={Arrow} className="icon-arrow" />
        </ActionTextWrap>
      </SectionText>
    </StyledMenuItem>
  );
};

export default MenuItem;
